import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { expVal } from '@confluence/feature-experiments';

import { PersistenceQuery } from './SpaceViewsPersistenceQueries.graphql';
import { SpaceRootQuery } from './SpaceViewsQueries.graphql';

export function preloadSpaceViews(spaceKey: string, isLicensed: boolean) {
	const queries: Promise<any>[] = [];
	if (!expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		queries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: SpaceRootQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}

	if (isLicensed) {
		queries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: PersistenceQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}
	return waitForAllReturnWhenError(queries);
}
